import request from '../utils/request';
import { stringify } from 'qs';

//获取价格产品列表
export async function getProducts (params: object) {
  return request(`/api/bill/device/price/product/list?${stringify(params)}`, {
    method: 'GET',
    requestType: 'form',
    data: params,
  })
}

// 获取设备价格点列表
export async function getPrices (params: object) {
  return request(`/api/bill/device/prices?${stringify(params)}`, {
    method: 'GET',
    requestType: 'form',
    data: params,
  })
}

// 点击购买
export async function buyDevice (params: object) {
  return request(`/api/bill/device/buy`, {
    method: 'POST',
    requestType: 'form',
    data: params,
  })
}
